// Workaround in order to create actions via constructor

export const unwrapAction = (store: any) => (next: any) => (action: any) => {
  next({ ...action });
};
